import Marquee from "react-fast-marquee";

const WORDS = [
  "Rasenpflege",
  "Heckenschnitt",
  "Baumpflege",
  "Pflanzenpflege",
  "Hausmeisterservice",
  "Entrümpelung",
  "Auf Anfrage",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-yx-border bg-yx-primary py-6 sm:py-8"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-3xl sm:text-5xl font-medium text-white/90 px-8">
              {w}
            </span>
            <span className="text-yx-accent text-2xl sm:text-4xl">✳</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
